import React from 'react';

import styles from './Navigation.module.css';

const NavBurger = ({ navBurger, setNavBurger }) => {
    return (
        <img
            src={!navBurger ? '/Navigation/menuIcon.png' : '/Navigation/closeIcon.png'}
            alt='Menu'
            className={styles.navBurger}
            onClick={() => setNavBurger(!navBurger)}
        />
    );
};

export default NavBurger;